/* eslint-disable no-console, no-undef */

import { register } from 'register-service-worker';
let swRegistration = null;




// if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.'
      );


    },
    registered(reg) {
      console.log('Service worker has been registered.');
      swRegistration = reg;

      setTimeout(() =>
        document.dispatchEvent(new CustomEvent('swRegistered', { detail: reg })), 2000);

      setInterval(() => {
        reg.update();
      }, 1000 * 60); // e.g. checks every minute



      self.addEventListener('push', function (event) {
        console.log('[Service Worker] Push Received.');
        console.log(`[Service Worker] Push had this data: "${event.data.text()}"`);

        let data = JSON.parse(event.data.text());

        const title = 'J🌰 Kalender';
        const options = {
          body: data["text"],
          icon: 'https://jazznuts.krueckl.de/img/icon.png',
          badge: 'https://jazznuts.krueckl.de/img/icon.png'
        };

        event.waitUntil(self.registration.showNotification(title, options));

        fetch("/pushReceived", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: event.data.text()
        })
      });


      self.addEventListener('notificationclick', function (event) {
        console.log('[Service Worker] Notification click received.');

        event.notification.close();

        event.waitUntil(
          clients.openWindow('https://jazznuts.krueckl.de')
        );
      });

    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated(reg) {
      console.log('New content is available; please refresh.');
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: reg.waiting })
      );
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    }



  });
// }

export { swRegistration };